import styled from 'styled-components'

export const CloseButton = styled.div`
  position: fixed;
  right: 5px;
  top: 5px;
  z-index: 1;
  background: white;
`
